import { render, staticRenderFns } from "./dingjia.vue?vue&type=template&id=6387a4f5&scoped=true&"
import script from "./dingjia.vue?vue&type=script&lang=js&"
export * from "./dingjia.vue?vue&type=script&lang=js&"
import style0 from "./dingjia.vue?vue&type=style&index=0&id=6387a4f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6387a4f5",
  null
  
)

export default component.exports